class CnRGWP {
    constructor(options) {
        this.options = options;
        
        this.unconfigured = [];
    }
    startListener() {
      console.error("STARTING LISTENER");
      document.addEventListener("CartUpdated",(event)=>{
			this.process(window.cart);
		});
    }
    
    process(cart,force_total) {
        let now = new Date();
        
        if (this.options.starts) {
          var start = Date.parse(this.options.starts);
          console.error(now,start,now<start);
          if (now<start) {
            
            return;
          }
        }
        if (this.options.ends) {
          var end = Date.parse(this.options.ends);
          if (now>end) {
            
            return;
          }
        }
      
        let gift_item = null;
        let gift_index = 0;
        cart.items.forEach((item,index)=>{
            if (item.properties && item.properties["_cr_gwp"]==this.options.campaign) {
                gift_item = item;
                gift_index = index+1;
            }
        });
        if (!force_total) {
          force_total = cart.items_subtotal_price;
        }
        let tier = this.options.tiers.find(
            tier=>force_total>=tier.min && force_total<=tier.max
        );

        console.error(cart);
        if (!tier) {
            if (gift_item) {
                this.removeItemAt(gift_index,()=>{
                  if (this.drawerIsOpen()) {
                            goCart.fetchAndOpenCart();
                          }
                });
            }
        } else {
            if (gift_item) {
                if (gift_item.id != tier.id) {
                    this.removeItemAt(gift_index,()=>{
                        console.error("readding",gift_item.properties);
                        this.addItem(tier.id,gift_item.properties,()=>{
                          
                          if (this.options.force_reload) {
                              window.setTimeout(()=>{
                                window.location.reload();
                              },1000);
                              
                          } else {
                              if (this.drawerIsOpen()) {
                                  goCart.fetchAndOpenCart();
                              }
                          }
                        });
                    });
                } 
            } else {
                 
             
              
             // document.querySelector("#cnr-modal-title").innerHTML = "Free ${tier.amount} Gift Card!";
             // MicroModal.show("cnr-modal");
                
              
                let properties =  {
                    "Gift Note": "",
                    "_Card Image": "https://cdn.shopify.com/s/files/1/0537/8297/0538/products/unnamed.jpg?v=1645559786",
                    "_Notify Sender": false,
                    "Recipient Name": "",
                    "Recipient Email": "",
                    "_Send To Self": false,
                    "Delivery Date": "2020-11-30",
                    "_Send Copy To Self": false,
                    "_cr_gwp":this.options.campaign,
                  };
                  this.addItem(tier.id,properties,()=>{goCart.fetchAndOpenCart()});
            }
        }
    }
    checkoutFieldValue(selector) {
      try {
        return parseInt(document.querySelector(`[${selector}]`).getAttribute(selector));
      } catch(e) {
        return 0;
      }
    }
    showRecipientForm(item,index) {
      console.error(item,index);
      let today = new Date();
      let iyh = new Date();
      iyh.setFullYear(today.getFullYear()+1);
      document.querySelector(".hystmodal__window").innerHTML=`<form id="card-gwp"><div style="padding:16px;">
         <div class="gvlo-gallery">
            <div class="carousel">
               <div class="image-container">
                  <div style="right: 0%;" class="gvlo-img-container"><img id="currentImage" src="//cdn.shopify.com/s/files/1/0537/8297/0538/products/unnamed.jpg?v=1645559786" alt="giftcard-image-1"> </div>
               </div>
           </div>
         </div>
         <div class="gvlo-form-content">
            <h2 class="gvlo-heading">Who's the lucky recipient of your ${(item.original_line_price/100).toFixed(2)} gift card?</h2>
            <div style="color:#990000" id="gwp-error" hidden></div>
            <!--
            <div class="gvlo-field gvlo-toggle svelte-12xebdh">
               <label for="" class="svelte-12xebdh">Sending as a gift?</label> 
               <div class="gvlo-toggle-disclaimer" tabindex="0"><span>The gift card you are buying will be emailed directly to the recipient.</span> <input type="checkbox" name="send_self" style="display: none;"></div>
            </div> -->
            <div class="gvlo-field gvlo-recipient-name svelte-12xebdh"><label for="Recipient Name" class="svelte-12xebdh">Recipient Name</label> <input id="Recipient Name" label="Recipient Name" name="Recipient Name" type="text" required="" placeholder="" class="svelte-12xebdh"></div>
            <div class="gvlo-field gvlo-recipient-email svelte-12xebdh"><label for="Recipient Email" class="svelte-12xebdh">Recipient Email</label> <input id="Recipient Email" label="Recipient Email" name="Recipient Email" type="email" required="" placeholder="" class="svelte-12xebdh"></div>
            <div class="gvlo-field gvlo-delivery-date svelte-12xebdh">
               <label for="Delivery Date" class="svelte-12xebdh">Delivery Date</label>  
               <div class="date">
                  <input min="${today.toJSON().slice(0, 10)}" max="${iyh.toJSON().slice(0, 10)}" onchange="t=>{}" id="datePicker" label="Delivery Date" name="Delivery Date" type="date" required="" placeholder="2022-11-30" autocomplete="off" class="flatpickr-input">
               </div>
            </div>
            <div class="gvlo-field gvlo-gift-note svelte-12xebdh"><label for="Gift Note" class="svelte-12xebdh">Gift Note (Optional)</label> <textarea id="Gift Note" label="Gift Note (Optional)" name="Gift Note" type="textarea" placeholder="Enjoy this gift card!" rows="3" class="svelte-12xebdh"></textarea></div>
            <button type="submit" class="gvlo-button button primary-button js-trigger-gwp">Set Recipient</button>
         </div>
      </div></form>`;
      
      let lb = new HystModal({linkAttributeName: 'data-hystmodal'});
      lb.open("#cnr-modal");
      try {
        console.error($("#datePicker"));
        $( function() {
          $("#datePicker").datepicker();
        });
      } catch(e) {
        console.error(e);
      }
      document.querySelector(".js-trigger-gwp").addEventListener("click",(event)=>{
        event.preventDefault();
        event.stopPropagation();
        this.handleFormSubmit(item,index,lb);
      });
    }
    queueUnconfigured(cart,item_ids) {
      this.unconfigured=[];
      
      cart.items.forEach((item,index)=>{
        if (item_ids.includes(item.id) 
            && 
            (!item.properties || !item.properties["Recipient Name"] || item.properties["Recipient Name"].trim().length<1)
            && (item.properties && !item.properties["_Send To Self"])
           ) {
              this.unconfigured.push([item,index+1]);
        }
      });
      this.processNextUnconfigured();
    }
    processNextUnconfigured() {
      if (this.unconfigured.length>0) {
        let nextItem = this.unconfigured.shift();
        console.error(nextItem,this.unconfigured);
        this.showRecipientForm(nextItem[0],nextItem[1]);
      } else {
       this.lastLooks();
      }
    }
    lastLooks() {
      fetch("/cart.json").then(result=>result.json()).then(cart=>{
          var actual_subtotal = this.checkoutFieldValue("data-checkout-payment-due-target") - this.checkoutFieldValue("data-checkout-total-shipping-target");
        
          this.options.force_reload = true;
          console.error("Reprocessing",cart.items_subtotal_price,actual_subtotal);
          this.process(cart,actual_subtotal);
        });
    }
    handleFormSubmit(item,index,modal) {
      let form = document.querySelector("#card-gwp");
      let error_holder = document.querySelector("#gwp-error");
      let errors = [];

      let default_properties =  {
        "Gift Note": "",
        "_Card Image": "https://cdn.shopify.com/s/files/1/0537/8297/0538/products/unnamed.jpg?v=1645559786",
        "_Notify Sender": false,
        "Recipient Name": "",
        "Recipient Email": "",
        "_Send To Self": false,
        "Delivery Date": "",
        "_Send Copy To Self": true,
      };
      if (item.properties==null) {
        item.properties={};
      }
      Object.keys(default_properties).forEach(key=>{
        if (!item.properties[key]) {
          item.properties[key] = default_properties[key];
        }
      });
      
      
      ["Recipient Name","Delivery Date","Gift Note"].forEach(field=>{
        let f = form.querySelector(`input[name="${field}"],textarea[name="${field}"]`);
        if (f) {
          if (f.hasAttribute("required") && (!f.value || f.value.trim().length<1)) {
            errors.push(`<li>Please enter a value for ${field}</li>`);
          }
           item.properties[field] = f.value;
        }
      });
      let f = form.querySelector(`input[name="Recipient Email"]`);
      if (f) {
        if (!f.value.match(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/gm)) {
          errors.push("<li>Please enter a valid email address</li>");
        }
        item.properties["Recipient Email"] = f.value;
      }
      if (errors.length>0) {
          error_holder.innerHTML = `<ul>${errors.join("")}</ul>`
          error_holder.removeAttribute("hidden");
      } else {
        modal.close();
        this.removeItemAt(index,()=>{
           this.addItem(item.id,item.properties,()=>{this.processNextUnconfigured();});
        });
      }
    }
    drawerIsOpen() {
       let cartDrawer = document.querySelector(".js-go-cart-drawer");
      if (cartDrawer && cartDrawer.classList.contains("is-open")) {
        goCart.fetchAndOpenCart();
      }
    }
    updated(callback) {
      callback();
    }
    addItem(id,properties,callback) {
        window.fetch("/cart/add.js",{
            method:"POST",
            body:JSON.stringify({id:id,quantity:1,properties:properties}),
            headers:{"Content-type":"application/json"}
        }).then(response=>response.json())
        .then(json=>this.updated(callback))
        .catch(error=>console.error("error",error));
    }
    removeItemAt(index,callback) {
        let quantity = 0;
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({'quantity':quantity, 'line':index}),
            headers: {
               'Content-Type': 'application/json',
            },
        })
        .then((response) => response.json())
        .then(() =>this.updated(callback))
        .catch((error) => {});
    }
}